import React from 'react'
import { Route, Switch } from 'react-router'
import BrowseCourses from '../pages/Course/BrowseCourses/BrowseCourses'
import BrowseClasses from '../pages/Class/BrowseClasses/BrowseClasses'
import ClassDetails from '../pages/Class/ClassDetails/ClassDetails'
import CourseDetails from '../pages/Course/CourseDetails/CourseDetails'
import SearchResults from '../pages/Search/SearchResults'

const BrowseWrapper = ({ match }) => {
    const { path } = match
    return (
        <Switch>
            <Route path={`${path}/courses`} component={BrowseCourses} exact />
            <Route path={`${path}/courses/:id`} component={CourseDetails} />
            <Route path={`${path}/classes`} component={BrowseClasses} exact />
            <Route path={`${path}/classes/:id`} component={ClassDetails} />
            <Route path={`${path}/search`} component={SearchResults} />
        </Switch>
    )
}

export default BrowseWrapper
